import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { ClientEnv } from 'constants/Chat.constants';

import { ClientEnvironment } from '@polyai/common/constants/global.constants';

import { projectInit } from 'actions';

export interface WebChatPanelState {
  isWebChatPanelOpen: boolean;
  clientEnv: ClientEnv;
}

const initialState: WebChatPanelState = {
  isWebChatPanelOpen: false,
  clientEnv: ClientEnvironment.SANDBOX,
};

const webChatPanelSlice = createSlice({
  name: 'webChatPanel',
  initialState,
  reducers: {
    openWebChatPanel: state => {
      state.isWebChatPanelOpen = true;
    },
    closeWebChatPanel: state => {
      state.isWebChatPanelOpen = false;
    },
    toggleWebChatPanel: state => {
      state.isWebChatPanelOpen = !state.isWebChatPanelOpen;
    },
    setWebClientEnv: (
      state,
      { payload: clientEnv }: PayloadAction<ClientEnv>,
    ) => {
      state.clientEnv = clientEnv;
    },
  },
  extraReducers: builder => {
    builder.addCase(projectInit, () => {
      return { ...initialState };
    });
  },
});

export const {
  openWebChatPanel,
  closeWebChatPanel,
  toggleWebChatPanel,
  setWebClientEnv,
} = webChatPanelSlice.actions;

export default webChatPanelSlice.reducer;
